import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeletePostMutationVariables = Types.Exact<{
  data: Types.DeletePostInput;
}>;


export type DeletePostMutation = { deletePost: { success?: boolean | null } };


export const DeletePostDocument = /*#__PURE__*/ gql`
    mutation DeletePost($data: DeletePostInput!) {
  deletePost(data: $data) {
    success
  }
}
    `;

export function useDeletePostMutation() {
  return Urql.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument);
};